import { render, staticRenderFns } from "./InlineGroup.vue?vue&type=template&id=65fc9698&scoped=true&"
var script = {}
import style0 from "./InlineGroup.vue?vue&type=style&index=0&id=65fc9698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc9698",
  null
  
)

export default component.exports